import { IconButton, Id, isSuccess, usePaginatedList, useToasts } from "@dgs/core";
import { AxiosResponse } from "axios";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
	filterId: Id | null;
	onExport: (search: string | null, filterId: Id | null, showOnlyOwnEvents?: boolean) => Promise<AxiosResponse>;
	showOnlyOwnEvents?: boolean;
}

export const EventExportAction: FC<Props> = ({ filterId, onExport, showOnlyOwnEvents }) => {
	const { t } = useTranslation();
	const { searchParams } = usePaginatedList();
	const { showToast } = useToasts();

	const handleExportEvents = async () => {
		const response = await onExport(searchParams?.search ?? null, filterId, showOnlyOwnEvents);
		if (isSuccess(response)) {
			showToast({ type: "success", body: t("An export is being created, please wait."), title: t("Export") });
		}
	};

	return (
		<IconButton type="button" title={t("Export")} onClick={handleExportEvents} icon="file_download" size="small" />
	);
};
